import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'skeleton-story-list',
  templateUrl: './skeleton-story-list.component.html',
  styleUrls: ['./skeleton-story-list.component.scss']
})
export class SkeletonStoryListComponent implements OnInit {

  @Input() countItem: number = 8;
  @Input() cssClassItem: string = '';
  @Input() isListView: boolean = false;
  @Input() showDate: boolean = true;
  @Input() showTags: boolean = true;
  @Input() showAuthor: boolean = true;
  @Input() showMedia: boolean = true; // New: Control media section visibility
  @Input() mediaType: 'image' | 'video' | 'mixed' = 'mixed'; // New: Media type
  @Input() showHeader: boolean = false; // New: Control header visibility
  @Input() showDescription: boolean = true; // New: Control description visibility
  @Input() showContributors: boolean = false; // New: Control contributors section
  @Input() imageHeight: number = 225;
  @Input() titleLines: number = 2;
  @Input() descriptionLines: number = 3;
  @Input() tagCount: number = 3;
  @Input() contributorCount: number = 2; // New: Number of contributor avatars
  
  listItem: number[] = [];

  constructor() { }

  ngOnInit() {
    this.renderItem();
  }

  private renderItem() {
    this.listItem = [];
    for (let i = 0; i < this.countItem; i++) {
      this.listItem.push(i);
    }
  }

}
